import PlayIcon from '../../assets/icons/components/PlayIcon'
import PauseIcon from '../../assets/icons/components/PauseIcon'
import { FlexBox } from '@fable/components'
import { css, useTheme } from '@fable/theme'

interface Props {
  loaded: boolean
  playing: boolean
  play: () => void
  pause: () => void
}

export const AudioPlayerButton: React.VFC<Props> = ({
  loaded,
  playing,
  play,
  pause,
}) => {
  const { colors, motion } = useTheme()

  const toggleAudio = () => (!playing ? play() : pause())

  const icon = playing ? <PauseIcon /> : <PlayIcon />

  const styles = {
    button: css`
      cursor: pointer;
      width: 38px;
      height: 38px;

      svg {
        width: 100%;
        height: 100%;

        path {
          fill: ${colors.blackSwan};
        }
      }
    `,
    loader: css`
      background: ${colors.whiteFang};
      border: 2px solid ${colors.blackSwan};
      border-radius: 50%;
      position: relative;
      width: 100%;
      height: 100%;
      ${motion.spin};

      &:after {
        content: '';
        display: block;
        border: 16px solid transparent;
        border-top: 20px solid ${colors.whiteFang};
        border-bottom: none;
        position: absolute;
        top: 0;
        left: 50%;
        right: 0;
        bottom: 0;
        transform: translate(-50%, -8%);
      }
    `,
  }

  const loader = (
    <div className={styles.loader}>
      <span />
    </div>
  )

  return (
    <FlexBox
      className={styles.button}
      onClick={toggleAudio}
      data-testid="audio-player-button"
      centerAll
    >
      {loaded ? icon : loader}
    </FlexBox>
  )
}
